export const segmentationThresholdColumns = [
  {
    display_name: "",
    key: "select",
    headerStyles: {
        background: "#7593F2",
        color:"#ffffff",
        padding: "4px 8px",
        width: "50px"
      },
    cellStyles: {
        width: "50px"
      },
    _config: {
      type: "checkbox",
      displayInColumn: true,
      value: "id",
      isClickable: "true"
    }
  },
  {
    display_name: "Attribute",
    key: "featureName"
  },
  {
    display_name: "Order",
    key: "order",
  },
  {
    display_name: "LB - Accuracy Threshold (duplicate)",
    key: "duplicateData1",
    _config: {
      type: "select",
      value: "",
      options: [
        {
          label: 60,
          value: 60,
        },
        {
          label: 65,
          value: 65,
        },
        {
          label: 70,
          value: 70,
        },
        {
          label: 75,
          value: 75,
        },
        {
          label: 80,
          value: 80,
        },
        {
          label: 85,
          value: 85,
        },
        {
          label: 90,
          value: 90,
        },
        {
          label: 95,
          value: 95,
        },
        {
          label: 98,
          value: 98,
        },
        {
          label: 100,
          value: 100,
        },
      ],
    },
  },
  {
    display_name: "UB - Accuracy Threshold (duplicate)",
    key: "duplicateData2",
    _config: {
      type: "select",
      value: "",
      options: [
        {
          label: 60,
          value: 60,
        },
        {
          label: 65,
          value: 65,
        },
        {
          label: 70,
          value: 70,
        },
        {
          label: 75,
          value: 75,
        },
        {
          label: 80,
          value: 80,
        },
        {
          label: 85,
          value: 85,
        },
        {
          label: 90,
          value: 90,
        },
        {
          label: 95,
          value: 95,
        },
        {
          label: 98,
          value: 98,
        },
        {
          label: 100,
          value: 100,
        },
      ],
    },
  },
  {
    display_name: "LB - Accuracy Threshold (overlapping)",
    key: "mergeableData1",
    _config: {
      type: "select",
      value: "",
      options: [
        {
          label: 60,
          value: 60,
        },
        {
          label: 65,
          value: 65,
        },
        {
          label: 70,
          value: 70,
        },
        {
          label: 75,
          value: 75,
        },
        {
          label: 80,
          value: 80,
        },
        {
          label: 85,
          value: 85,
        },
        {
          label: 90,
          value: 90,
        },
        {
          label: 95,
          value: 95,
        },
        {
          label: 98,
          value: 98,
        },
        {
          label: 100,
          value: 100,
        },
      ],
    },
  },
  {
    display_name: "UB - Accuracy Threshold (overlapping)",
    key: "mergeableData2",
    _config: {
      type: "select",
      value: "",
      options: [
        {
          label: 60,
          value: 60,
        },
        {
          label: 65,
          value: 65,
        },
        {
          label: 70,
          value: 70,
        },
        {
          label: 75,
          value: 75,
        },
        {
          label: 80,
          value: 80,
        },
        {
          label: 85,
          value: 85,
        },
        {
          label: 90,
          value: 90,
        },
        {
          label: 95,
          value: 95,
        },
        {
          label: 98,
          value: 98,
        },
        {
          label: 100,
          value: 100,
        },
      ],
    },
  },
];
